import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class Decking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: '',
      width: '',
      factor: '',
      amount: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAmount = this.handleChange.bind(null, 'amount');
    this.handleChangeFactor = this.handleChange.bind(null, 'factor');
    this.handleChangeLength = this.handleChange.bind(null, 'length');
    this.handleChangeWidth = this.handleChange.bind(null, 'width');
  }
  handleChange(key, value) {
    const _this$state = this.state,
      beforeLength = _this$state.length,
      beforeWidth = _this$state.width,
      beforeFactor = _this$state.factor,
      beforeAmount = _this$state.amount;
    const onCalc = this.props.onCalc;
    if (key === 'length' && beforeLength !== value || key === 'width' && beforeWidth !== value || key === 'factor' && beforeFactor !== value || key === 'amount' && beforeAmount !== value) {
      this.setState({
        [key]: value
      }, () => {
        const _this$state2 = this.state,
          length = _this$state2.length,
          width = _this$state2.width,
          factor = _this$state2.factor,
          amount = _this$state2.amount;
        if (length !== '' && width !== '' && factor !== '' && amount !== '') {
          // Calculate the surface area
          const total = length * width * factor * amount;

          // If it's a valid value, pass it up
          if (!_.isNaN(total)) {
            onCalc(+total.toFixed(2));
          }
        }
      });
    }
  }
  render() {
    const _this$state3 = this.state,
      length = _this$state3.length,
      width = _this$state3.width,
      factor = _this$state3.factor,
      amount = _this$state3.amount;
    const result = this.props.result;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "Length x Width or Height x Corrugation Factor x Amount = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Length",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeLength,
      value: length
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Width or Height",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeWidth,
      value: width
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Corrugation Factor",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeFactor,
      value: factor
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Amount",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeAmount,
      value: amount
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
Decking.defaultProps = {
  onCalc: null,
  result: null
};
Decking.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};